import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import DatasetTitle from "components/basic/display-titles/DatasetTitle";
import { InputText } from "primereact/inputtext";

interface PieChartEditorProps {
  currentConfig: any;
  setCurrentConfig: (config: any) => void;
}

const PieChartEditor = ({ currentConfig, setCurrentConfig }: PieChartEditorProps) => {
  const [identifiers, setIdentifiers] = useState<{ identifier: string; overriddenTitle: string }[]>([]);
  useEffect(() => {
    const transformedIdentifiers = currentConfig.identifiers.map((identifier: any) => ({
      identifier: identifier.identifier,
      overriddenTitle: identifier.overriddenTitle,
    }));
    setIdentifiers(transformedIdentifiers);
  }, [currentConfig.identifiers]);

  const titleBodyTemplate = (rowData: any) => {
    return <DatasetTitle identifier={rowData.identifier} />;
  };

  const textEditor = (options: any) => {
    return (
      <InputText
        value={options.value || ""}
        onChange={e => options.editorCallback(e.target.value)}
        style={{ width: "100%" }}
      />
    );
  };

  const overriddenTitleBodyTemplate = (rowData: any) => {
    return <div>{rowData.overriddenTitle}</div>;
  };

  const onRowEditComplete = (e: any): void => {
    const { newData, index } = e;

    if (newData && index !== undefined && index !== null) {
      const updatedIdentifiers: { identifier: string; overriddenTitle: string }[] = [
        ...identifiers,
      ];
      updatedIdentifiers[index] = { ...updatedIdentifiers[index], ...newData };
      setIdentifiers(updatedIdentifiers);
      setCurrentConfig({
        ...currentConfig,
        identifiers: updatedIdentifiers,
      });
    } else {
      console.error("Invalid edit event data:", e);
    }
  };

  const handleRowReorderEvt = (e: any) => {
    const reorderedData = [...identifiers];
    const [removed] = reorderedData.splice(e.from, 1);
    reorderedData.splice(e.to, 0, removed);
    setIdentifiers(reorderedData);
    setCurrentConfig({
      ...currentConfig,
      identifiers: reorderedData,
    });
  };

  return (
    <div>
      <DataTable
        value={identifiers}
        onRowEditComplete={onRowEditComplete}
        editMode="row"
        onRowReorder={handleRowReorderEvt}
        reorderableRows
      >
        <Column
          field="identifier"
          header="Title"
          body={titleBodyTemplate}
          style={{ width: "50%" }}
        />
        <Column
          className="p-0"
          field="overriddenTitle"
          header="Overridden Title"
          alignHeader="left"
          style={{ width: "30%", textAlign: "left" }}
          align="center"
          editor={options => textEditor(options)}
          body={overriddenTitleBodyTemplate}
        />
        <Column rowEditor align="center" style={{ width: "10%" }} />
      </DataTable>
    </div>
  );
};

export default PieChartEditor;
